export default __webpack_public_path__ + "static/media/bigLogo.a46b66ee.png";